import React from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';

/**
 * OtherFormコンポーネント用のPropsです。
 * @interface OtherFormProps
 */
interface OtherFormProps {

  /**
   * その他
   * @type {InputFieldState}
   * @memberof OtherFormProps
   */
  other: InputFieldState;

  /**
   * その他を設定する関数
   * @memberof OtherFormProps
   */
  onChange: (other: InputFieldState) => void;
  
}

/**
 * その他フォームのコンポーネントです。
 * @param {object} props - プロパティ
 * @param {string} props.other - 表示するその他
 * @param {function} props.onChange - その他が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - その他フォームのJSX要素
 */
const OtherForm: React.FC<OtherFormProps> = ({ other, onChange }) => {

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された識別番号を整形し、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onChange({
      value: value,
      errorMessage: ''
    });
  };

  return (
    <Form.Group className="mb-3 row">
      <Form.Label className="col-lg-2 col-12">
        その他
        <span className="text-small text-secondary ms-3">※任意</span>
        {/* <span className="text-small text-danger ms-3">※必須</span> */}
      </Form.Label>
      <div className="col-lg-10 col-12 ps-lg-5">
        <Form.Control as="textarea" onChange={handleChange} rows={3} value={other.value} />
        {other.errorMessage !== '' ? <div className="text-end text-danger small">{other.errorMessage}</div> : ''}
      </div>
    </Form.Group>
  );
}

export default OtherForm;